import { SettingConst } from '../../types';

/**
 * Experiment to use composable product tiles on homepage layout elements.
 * https:www.notion.so/faire/MarketplaceProduct-Migration-Path-WIP-1222efb5c25a80a0b39aeb0a44df5873?pvs=4
 */
export const USE_COMPOSABLE_PRODUCT_TILES_LAYOUT_ELEMENTS_241022 =
  'USE_COMPOSABLE_PRODUCT_TILES_LAYOUT_ELEMENTS_241022' as SettingConst<
    'USE_COMPOSABLE_PRODUCT_TILES_LAYOUT_ELEMENTS_241022',
    boolean,
    'LOGGED_IN_RETAILER'
  >;
